import React, { useEffect, useRef } from 'react';

const ProcessAnimation = () => {
    const containerRef = useRef(null);
    const bgElementsRef = useRef(null);
    const progressRingCircleRef = useRef(null);
    const progressCounterRef = useRef(null);
    
    // Global variables like in the original HTML
    let mediaFiles = [];
    let processingProgress = 0;
    let isProcessing = false;
    let processingInterval = null;
    let nextYPosition = 150;
    const yStep = 100;
    let lastFileTime = 0;
    let colorIndex = 0;
    let docIndex = 0;

    // Color schemes for alternating media icons
    const colorSchemes = [
        { buttonColor: "#ef4444", waveColor: "#ef4444" }, // Red
        { buttonColor: "#3b82f6", waveColor: "#3b82f6" }, // Blue
        { buttonColor: "#10b981", waveColor: "#10b981" }, // Green
        { buttonColor: "#8b5cf6", waveColor: "#8b5cf6" }, // Purple
        { buttonColor: "#eab308", waveColor: "#eab308" }  // Yellow
    ];

    // SVG templates for documents - ensuring all types are used
    const docTypes = [
        {
            type: 'PDF',
            color: '#ef4444', // Red
            svg: `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="60" viewBox="0 0 384 512" fill="#ef4444"><path d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm250.2-143.7c-12.2-12-47-8.7-64.4-6.5-17.2-10.5-28.7-25-36.8-46.3 3.9-16.1 10.1-40.6 5.4-56-4.2-26.2-37.8-23.6-42.6-5.9-4.4 16.1-.4 38.5 7 67.1-10 23.9-24.9 56-35.4 74.4-20 10.3-47 26.2-51 46.2-3.3 15.8 26 55.2 76.1-31.2 22.4-7.4 46.8-16.5 68.4-20.1 18.9 10.2 41 17 55.8 17 25.5 0 28-28.2 17.5-38.7zm-198.1 77.8c5.1-13.7 24.5-29.5 30.4-35-19 30.3-30.4 35.7-30.4 35zm81.6-190.6c7.4 0 6.7 32.1 1.8 40.8-4.4-13.9-4.3-40.8-1.8-40.8zm-24.4 136.6c9.7-16.9 18-37 24.7-54.7 8.3 15.1 18.9 27.2 30.1 35.5-20.8 4.3-38.9 13.1-54.8 19.2zm131.6-5s-5 6-37.3-7.8c35.1-2.6 40.9 5.4 37.3 7.8z"/></svg>`
        },
        {
            type: 'DOC',
            color: '#3b82f6', // Blue
            svg: `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="60" viewBox="0 0 384 512" fill="#3b82f6"><path d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm220.1-208c-5.7 0-10.6 4-11.7 9.5-20.6 97.7-20.4 95.5-21 103.5-.2-1.2-.4-2.6-.7-4.3-.8-5.1.3.2-23.6-99.5-1.3-5.4-6.1-9.2-11.7-9.2h-13.3c-5.5 0-10.3 3.8-11.7 9.1-24.4 99-24 96.2-24.8 103.7-.1-1.1-.2-2.5-.5-4.2-.7-5.2-14.1-73.3-19.1-99-1.1-5.6-6-9.7-11.8-9.7h-16.8c-7.8 0-13.5 7.3-11.7 14.8 8 32.6 26.7 109.5 33.2 136 1.3 5.4 6.1 9.1 11.7 9.1h25.2c5.5 0 10.3-3.7 11.6-9.1l17.9-71.4c1.5-6.2 2.5-12 3-17.3l2.9 17.3c.1.4 12.6 50.5 17.9 71.4 1.3 5.3 6.1 9.1 11.6 9.1h24.7c5.5 0 10.3-3.7 11.6-9.1 20.8-81.9 30.2-119 34.5-136 1.9-7.6-3.8-14.9-11.6-14.9h-15.8z"/></svg>`
        },
        {
            type: 'TXT',
            color: '#10b981', // Green
            svg: `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="60" viewBox="0 0 384 512" fill="#10b981"><path d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm144-96H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h112c8.8 0 16-7.2 16-16s-7.2-16-16-16zm96-16H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h208c8.8 0 16-7.2 16-16s-7.2-16-16-16zm-96-96H80c-8.8 0-16 7.2-16 16s7.2 16 16 16h112c8.8 0 16-7.2 16-16s-7.2-16-16-16z"/></svg>`
        },
        {
            type: 'MD',
            color: '#8b5cf6', // Purple
            svg: `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="60" viewBox="0 0 384 512" fill="#8b5cf6"><path d="M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm218.7-242.7c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-62.6 62.6-29.4-29.4c-1.6-1.6-3.6-2.3-5.7-2.3-2 0-4.1.8-5.7 2.3l-11.3 11.3c-3.1 3.1-3.1 8.2 0 11.3l46.3 46.3c3.1 3.1 8.2 3.1 11.3 0l79.6-79.6c3.1-3.1 3.1-8.2 0-11.3l-11.1-11.2z"/></svg>`
        }
    ];

    const createAudioIcon = (colorScheme) => {
        return `<div class="audio-icon">
            <div class="play-button" style="background-color: ${colorScheme.buttonColor};">
                <div class="play-triangle"></div>
            </div>
            <div class="waveform">
                <div class="wave-bar" style="background-color: ${colorScheme.waveColor}; animation: wave1 1.5s infinite;"></div>
                <div class="wave-bar" style="background-color: ${colorScheme.waveColor}; animation: wave2 1.5s infinite 0.1s;"></div>
                <div class="wave-bar" style="background-color: ${colorScheme.waveColor}; animation: wave3 1.5s infinite 0.2s;"></div>
                <div class="wave-bar" style="background-color: ${colorScheme.waveColor}; animation: wave4 1.5s infinite 0.3s;"></div>
                <div class="wave-bar" style="background-color: ${colorScheme.waveColor}; animation: wave5 1.5s infinite 0.4s;"></div>
                <div class="wave-bar" style="background-color: ${colorScheme.waveColor}; animation: wave6 1.5s infinite 0.5s;"></div>
                <div class="wave-bar" style="background-color: ${colorScheme.waveColor}; animation: wave7 1.5s infinite 0.6s;"></div>
                <div class="wave-bar" style="background-color: ${colorScheme.waveColor}; animation: wave8 1.5s infinite 0.7s;"></div>
            </div>
        </div>`;
    };

    const setProgress = (percent) => {
        if (progressRingCircleRef.current && progressCounterRef.current) {
            const radius = 52;
            const circumference = radius * 2 * Math.PI;
            const offset = circumference - percent / 100 * circumference;
            progressRingCircleRef.current.style.strokeDashoffset = offset;
            progressCounterRef.current.textContent = `${Math.round(percent)}%`;
        }
    };

    const createMatrixCode = () => {
        const matrixChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$%^&*()_+-=[]{}|;:,./<>?";
        const purpleColors = ['#a855f7', '#9333ea', '#c084fc', '#8b5cf6'];

        const createMatrixColumn = (xPercent, color) => {
            const column = document.createElement('div');
            column.className = 'matrix-column';
            column.style.left = `${xPercent}%`;
            const duration = Math.random() * 15 + 10;
            column.style.animation = `matrixRain ${duration}s linear infinite`;
            column.style.animationDelay = `${Math.random() * -20}s`;
            column.style.opacity = `${Math.random() * 0.4 + 0.6}`;
            column.style.color = color;
            column.style.textShadow = `0 0 5px ${color}`;
            
            // More chars per column for denser effect (10-25 chars)
            const numChars = Math.floor(Math.random() * 15) + 10;
            for (let j = 0; j < numChars; j++) {
                const char = document.createElement('div');
                char.className = 'matrix-char';
                char.textContent = matrixChars.charAt(Math.floor(Math.random() * matrixChars.length));
                char.style.animationDelay = `${Math.random() * 2}s`;
                column.appendChild(char);
                setInterval(() => {
                    if (Math.random() > 0.8) {
                        char.textContent = matrixChars.charAt(Math.floor(Math.random() * matrixChars.length));
                    }
                }, 300);
            }
            if (bgElementsRef.current) {
                bgElementsRef.current.appendChild(column);
            }
        };
        
        // More columns for denser effect (8 per side)
        for (let i = 0; i < 8; i++) {
            createMatrixColumn(Math.random() * 30, purpleColors[Math.floor(Math.random() * purpleColors.length)]);
        }
        for (let i = 0; i < 8; i++) {
            createMatrixColumn(70 + Math.random() * 30, purpleColors[Math.floor(Math.random() * purpleColors.length)]);
        }
    };

    const createMediaFile = () => {
        const now = Date.now();
        if (now - lastFileTime < 7000) {
            setTimeout(createMediaFile, 7000 - (now - lastFileTime));
            return;
        }

        if (mediaFiles.length >= 5) {
            setTimeout(createMediaFile, 2000);
            return;
        }

        lastFileTime = now;
        
        const currentColorScheme = colorSchemes[colorIndex % colorSchemes.length];
        colorIndex++;
        
        const mediaFile = document.createElement('div');
        mediaFile.className = 'media-file';
        mediaFile.innerHTML = createAudioIcon(currentColorScheme);
        
        mediaFile.style.top = `${nextYPosition}px`;
        nextYPosition = (nextYPosition + yStep) % 400;
        if (nextYPosition < 150) nextYPosition = 150;
        
        // Ensure we cycle through all document types
        const currentDocType = docTypes[docIndex % docTypes.length];
        docIndex++;
        
        const mediaInfo = {
            element: mediaFile,
            yPos: mediaFile.style.top,
            docType: currentDocType
        };
        
        mediaFiles.push(mediaInfo);
        if (containerRef.current) {
            containerRef.current.appendChild(mediaFile);
        }
        
        setTimeout(() => {
            if (!isProcessing) {
                isProcessing = true;
                processFiles();
            }
        }, 4000);
        
        setTimeout(createMediaFile, 7000);
    };

    const processFiles = () => {
        if (processingInterval) clearInterval(processingInterval);
        
        processingProgress = 0;
        setProgress(0);
        
        processingInterval = setInterval(() => {
            processingProgress += 1;
            setProgress(processingProgress);
            
            if (processingProgress >= 100) {
                clearInterval(processingInterval);
                
                if (mediaFiles.length > 0) {
                    const mediaInfo = mediaFiles.shift();
                    createDocument(mediaInfo);
                }
                
                if (mediaFiles.length > 0) {
                    setTimeout(() => {
                        isProcessing = true;
                        processFiles();
                    }, 500);
                } else {
                    isProcessing = false;
                }
            }
        }, 30);
    };

    const createDocument = (mediaInfo) => {
        const doc = document.createElement('div');
        doc.className = 'document';
        doc.innerHTML = `
            ${mediaInfo.docType.svg}
            <div class="doc-progress">
                <div class="doc-progress-bar"></div>
            </div>
            <div class="checkmark">✓</div>
        `;
        
        doc.style.top = mediaInfo.yPos;
        doc.style.left = `calc(50% + 100px)`;
        
        if (containerRef.current) {
            containerRef.current.appendChild(doc);
        }
        
        setTimeout(() => {
            const progressBar = doc.querySelector('.doc-progress-bar');
            if (progressBar) {
                progressBar.style.width = '100%';
                
                setTimeout(() => {
                    if (progressBar) {
                        progressBar.style.width = '0';
                        const checkmark = doc.querySelector('.checkmark');
                        if (checkmark) {
                            checkmark.style.opacity = '1';
                        }
                        
                        setTimeout(() => {
                            doc.style.opacity = '0';
                            setTimeout(() => {
                                if (containerRef.current && doc.parentNode) {
                                    containerRef.current.removeChild(doc);
                                }
                            }, 500);
                        }, 500);
                    }
                }, 1500);
            }
        }, 500);
    };

    useEffect(() => {
        if (progressRingCircleRef.current) {
            const radius = 52;
            const circumference = radius * 2 * Math.PI;
            progressRingCircleRef.current.style.strokeDasharray = `${circumference} ${circumference}`;
            progressRingCircleRef.current.style.strokeDashoffset = circumference;
        }

        setProgress(0);
        createMatrixCode();
        createMediaFile();
    }, [createMediaFile]);

    return (
        <div className="media-converter-container bg-matrix">
            <style>{`
          
                
                .media-converter-container {
                    width: 100%;
                    height: 500px;
                    position: relative;
                    overflow: hidden;
                    background-color: #0c0020;
                    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                    transition: background 1s ease;
                }

                .media-file {
                    position: absolute;
                    left: -100px;
                    animation: moveToSphere 4s linear forwards;
                }

                .document {
                    position: absolute;
                    opacity: 0;
                    transform: scale(0.5);
                    animation: documentAppear 3s forwards;
                }

                .processing-sphere {
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: 180px;
                    height: 180px;
                    border-radius: 50%;
                    background: radial-gradient(circle at 30% 30%, #9333ea, #4c1d95);
                    box-shadow: 0 0 50px #9333ea;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    z-index: 10;
                }

                .sphere-pulse {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    background: transparent;
                    border: 2px solid rgba(147, 51, 234, 0.5);
                    animation: pulse 2s infinite;
                }

                .progress-ring {
                    transform: rotate(-90deg);
                    position: absolute;
                }

                .progress-counter {
                    position: absolute;
                    color: white;
                    font-size: 24px;
                    font-weight: bold;
                    text-align: center;
                    z-index: 20;
                }

                .vertical-stream {
                    position: absolute;
                    left: 50%;
                    width: 40px;
                    transform: translateX(-50%);
                    background: linear-gradient(to bottom, rgba(147, 51, 234, 0) 0%, rgba(147, 51, 234, 0.3) 50%, rgba(147, 51, 234, 0) 100%);
                    z-index: 5;
                }

                .top-stream {
                    top: 0;
                    height: calc(50% - 90px);
                    animation: streamPulse 3s infinite;
                }

                .bottom-stream {
                    bottom: 0;
                    height: calc(50% - 90px);
                    animation: streamPulse 3s infinite 1.5s;
                }

                @keyframes streamPulse {
                    0%, 100% {
                        opacity: 0.3;
                    }
                    50% {
                        opacity: 0.6;
                    }
                }

                @keyframes pulse {
                    0% {
                        transform: scale(1);
                        opacity: 0.8;
                    }
                    100% {
                        transform: scale(1.5);
                        opacity: 0;
                    }
                }

                @keyframes moveToSphere {
                    0% {
                        left: -100px;
                        opacity: 0;
                        transform: translateY(0) scale(0.8);
                    }
                    20% {
                        opacity: 1;
                        transform: translateY(0) scale(1);
                    }
                    90% {
                        left: calc(50% - 40px);
                        opacity: 1;
                        transform: translateY(0) scale(1);
                    }
                    100% {
                        left: calc(50% - 20px);
                        opacity: 0;
                        transform: translateY(0) scale(0.5);
                    }
                }

                @keyframes documentAppear {
                    0% {
                        opacity: 0;
                        transform: scale(0.5) translateX(0);
                    }
                    20% {
                        opacity: 1;
                        transform: scale(1) translateX(0);
                    }
                    80% {
                        opacity: 1;
                        transform: scale(1) translateX(150px);
                    }
                    95% {
                        opacity: 0.5;
                        transform: scale(1.2) translateX(180px);
                    }
                    100% {
                        opacity: 0;
                        transform: scale(0.8) translateX(200px);
                    }
                }

                .doc-progress {
                    position: absolute;
                    bottom: -15px;
                    left: 0;
                    width: 100%;
                    height: 6px;
                    background-color: rgba(255, 255, 255, 0.2);
                    border-radius: 3px;
                    overflow: hidden;
                }

                .doc-progress-bar {
                    height: 100%;
                    width: 0%;
                    background-color: #10b981;
                    border-radius: 3px;
                    transition: width 1.5s ease-in-out;
                }

                .checkmark {
                    position: absolute;
                    bottom: -15px;
                    left: 50%;
                    transform: translateX(-50%);
                    color: #10b981;
                    font-size: 20px;
                    opacity: 0;
                }

                .glow {
                    position: absolute;
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    background: radial-gradient(circle, rgba(147, 51, 234, 0.8) 0%, rgba(147, 51, 234, 0) 70%);
                    filter: blur(15px);
                    z-index: -1;
                }

                .audio-icon {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    width: 60px;
                    height: 70px;
                }

                .play-button {
                    width: 40px;
                    height: 40px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-bottom: 8px;
                    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.3);
                }

                .play-triangle {
                    width: 0;
                    height: 0;
                    border-top: 10px solid transparent;
                    border-bottom: 10px solid transparent;
                    border-left: 15px solid white;
                    margin-left: 3px;
                }

                .waveform {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 50px;
                    height: 15px;
                }

                .wave-bar {
                    width: 3px;
                    margin: 0 1px;
                    border-radius: 1px;
                }

                @keyframes wave1 {
                    0%, 100% { height: 5px; }
                    25% { height: 12px; }
                    50% { height: 7px; }
                    75% { height: 10px; }
                }

                @keyframes wave2 {
                    0%, 100% { height: 9px; }
                    25% { height: 5px; }
                    50% { height: 13px; }
                    75% { height: 7px; }
                }

                @keyframes wave3 {
                    0%, 100% { height: 13px; }
                    25% { height: 7px; }
                    50% { height: 10px; }
                    75% { height: 12px; }
                }

                @keyframes wave4 {
                    0%, 100% { height: 10px; }
                    25% { height: 13px; }
                    50% { height: 5px; }
                    75% { height: 9px; }
                }

                @keyframes wave5 {
                    0%, 100% { height: 7px; }
                    25% { height: 10px; }
                    50% { height: 12px; }
                    75% { height: 5px; }
                }

                @keyframes wave6 {
                    0%, 100% { height: 12px; }
                    25% { height: 9px; }
                    50% { height: 7px; }
                    75% { height: 13px; }
                }

                @keyframes wave7 {
                    0%, 100% { height: 4px; }
                    25% { height: 7px; }
                    50% { height: 9px; }
                    75% { height: 6px; }
                }

                @keyframes wave8 {
                    0%, 100% { height: 9px; }
                    25% { height: 4px; }
                    50% { height: 11px; }
                    75% { height: 7px; }
                }

                .bg-controls {
                    position: fixed;
                    bottom: 20px;
                    left: 50%;
                    transform: translateX(-50%);
                    display: flex;
                    gap: 10px;
                    z-index: 100;
                    flex-wrap: wrap;
                    justify-content: center;
                    max-width: 90%;
                    padding: 10px;
                    background: rgba(0, 0, 0, 0.3);
                    border-radius: 15px;
                }

                .bg-button {
                    padding: 8px 12px;
                    border-radius: 20px;
                    background: rgba(255, 255, 255, 0.2);
                    color: white;
                    border: none;
                    cursor: pointer;
                    font-size: 14px;
                    transition: all 0.3s ease;
                }

                .bg-button:hover {
                    background: rgba(255, 255, 255, 0.3);
                }

                .bg-button.active {
                    background: rgba(147, 51, 234, 0.6);
                    box-shadow: 0 0 10px rgba(147, 51, 234, 0.5);
                }

                .bg-matrix {
                    background-color: #0c0020;
                    position: relative;
                    overflow: hidden;
                }

                .matrix-column {
                    position: absolute;
                    top: -20px;
                    font-family: monospace;
                    font-size: 14px;
                    color: #a855f7;
                    text-shadow: 0 0 5px #9333ea;
                    z-index: 0;
                    white-space: nowrap;
                    opacity: 0.8;
                }

                .matrix-char {
                    display: block;
                    text-align: center;
                    animation: fadeMatrix 2s infinite;
                }

                @keyframes fadeMatrix {
                    0%, 100% { opacity: 0.3; }
                    50% { opacity: 1; }
                }

                @keyframes matrixRain {
                    0% {
                        transform: translateY(-100%);
                    }
                    100% {
                        transform: translateY(100vh);
                    }
                }

                .full-screen-container {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                }

                .animation-container {
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    top: 0;
                    left: 0;
                }
            `}</style>
            
            <div ref={bgElementsRef} id="bg-elements"></div>
            
            <div className="full-screen-container">
                <div className="vertical-stream top-stream"></div>
                <div className="vertical-stream bottom-stream"></div>
                
                <div className="processing-sphere">
                    <div className="sphere-pulse"></div>
                    <div className="sphere-pulse" style={{ animationDelay: '0.5s' }}></div>
                    <div className="glow"></div>
                    <svg className="progress-ring" width="120" height="120">
                        <circle 
                            className="progress-ring-circle" 
                            stroke="#ffffff" 
                            strokeOpacity="0.3"
                            strokeWidth="8" 
                            fill="transparent" 
                            r="52" 
                            cx="60" 
                            cy="60"/>
                        <circle 
                            ref={progressRingCircleRef}
                            className="progress-ring-circle-progress" 
                            stroke="#ffffff" 
                            strokeWidth="8" 
                            fill="transparent" 
                            r="52" 
                            cx="60" 
                            cy="60"
                            strokeDasharray="326.73"
                            strokeDashoffset="326.73"/>
                    </svg>
                    <div ref={progressCounterRef} className="progress-counter">0%</div>
                </div>

                <div ref={containerRef} className="animation-container"></div>
            </div>
        </div>
    );
};

export default ProcessAnimation; 